module.exports = "/_next/static/resources/art-f30d3cf3e8d8e3606ae0bb7ce58269f5.webp";